import React, {useState} from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";

import RefundItemsListComponent from "@/pages/admin/refund/items/_section/RefundItemsListComponent";


function AdminRefundListPage(props) {



    return (
        <AdminLayout pageTitle={'لیست درخواست‌های بازگشت وجه'} backTo={URLS.admin.refund.dashboard}>

          <RefundItemsListComponent />

        </AdminLayout>
    );
}

export default AdminRefundListPage;